import { render } from "./index.vue?vue&type=template&id=51da3edc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=51da3edc&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51da3edc"],['__file',"src/components/WizardConfiguracaoPendente/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51da3edc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51da3edc', __exports__)) {
    console.log('reload')
    api.reload('51da3edc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=51da3edc&scoped=true", () => {
    console.log('re-render')
    api.rerender('51da3edc', render)
  })

}


export default __exports__